<template>
  <div class="fancy-title" :class="{'-link' : !status, '-opacity' : opacity}" @click="action()">
    <component v-if="icon" :is="`icon-${icon}`" />
    <span class="fancy-title__text">{{text}}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    opacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status: function() {
      return !this._events.action;
    }
  },
  methods: {
    action: function() {
      let vm = this;

      if (vm.status) return;

      vm.process = true;

      vm.$emit("action");
    }
  }
};
</script>